import { render, staticRenderFns } from "./CircleDetail.vue?vue&type=template&id=0b6dd09a&scoped=true"
import script from "./CircleDetail.vue?vue&type=script&lang=js"
export * from "./CircleDetail.vue?vue&type=script&lang=js"
import style0 from "./CircleDetail.vue?vue&type=style&index=0&id=0b6dd09a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b6dd09a",
  null
  
)

export default component.exports